module.exports = __webpack_public_path__ + "static/media/img-header-desk.c0dcf141.jpg";